import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useHlsContext } from "../../../context/Hls";
import { usePlaybackContext } from "../../../context/Playback";
import { useUIContext } from "../../../context/UI";
import { useTranslation } from "../../../hooks";
import OptionButton from "./OptionButton";
import Submenu from "./Submenu";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Settings = function Settings(_ref) {
  var section = _ref.section,
    onBack = _ref.onBack,
    changeSection = _ref.changeSection;
  var _usePlaybackContext = usePlaybackContext(),
    currentSpeed = _usePlaybackContext.currentSpeed;
  var _useHlsContext = useHlsContext(),
    qualities = _useHlsContext.qualities,
    currentQuality = _useHlsContext.currentQuality,
    hasLowQuality = _useHlsContext.hasLowQuality;
  var _useUIContext = useUIContext(),
    hideSpeedOptions = _useUIContext.hideSpeedOptions,
    autoplayNext = _useUIContext.autoplayNext,
    toggleAutoplay = _useUIContext.toggleAutoplay;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return section ? /*#__PURE__*/_jsx(Submenu, _objectSpread(_objectSpread({}, section), {}, {
    onBack: onBack
  })) : /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col w-full",
    children: [qualities && /*#__PURE__*/_jsx(OptionButton, {
      label: t('QUALITY'),
      value: currentQuality ? currentQuality.label : undefined,
      id: "quality",
      changeSection: changeSection,
      hasLowQuality: hasLowQuality
    }), !hideSpeedOptions && /*#__PURE__*/_jsx(OptionButton, {
      label: t('SPEED'),
      value: currentSpeed.label,
      id: "speed",
      changeSection: changeSection
    }), toggleAutoplay && /*#__PURE__*/_jsx(OptionButton, {
      label: t('AUTOPLAY'),
      value: autoplayNext,
      onSwitch: toggleAutoplay
    })]
  });
};
export default Settings;